import { render, staticRenderFns } from "./batchOrderReview.vue?vue&type=template&id=1f47bdbb&scoped=true"
import script from "./batchOrderReview.vue?vue&type=script&lang=js"
export * from "./batchOrderReview.vue?vue&type=script&lang=js"
import style0 from "./batchOrderReview.vue?vue&type=style&index=0&id=1f47bdbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f47bdbb",
  null
  
)

export default component.exports